/**
 * Renders a button HTML string from a button mapping entry.
 * @param {{ key?: string, text?: any, title?: any, icon?: string, className?: string, showIf?: Function } | null} mapping
 * @param {*} data
 * @param {*} row
 * @returns {string}
 */
export function renderButtonCell(mapping, data, row) {
    if (!mapping) return data == null ? '' : String(data);

    if (typeof mapping.showIf === 'function' && !mapping.showIf(row, data)) {
        return '';
    }

    let resolvedLabel;
    if (typeof mapping.text === 'function') {
        resolvedLabel = mapping.text(data, row);
    } else if (mapping.text != null && mapping.text !== '') {
        resolvedLabel = mapping.text;
    } else {
        resolvedLabel = data;
    }

    const resolvedTitle = typeof mapping.title === 'function'
        ? mapping.title(data, row)
        : mapping.title;

    const key = mapping.key || String(data ?? 'action').trim().toLowerCase().replace(/\s+/g, '-');
    const btnClass = mapping.className || 'btn-outline-secondary';
    const label = resolvedLabel ?? '';
    const title = (resolvedTitle ?? resolvedLabel ?? key) || '';
    const iconHtml = mapping.icon ? `<i class="${mapping.icon}"></i> ` : '';

    return `<button type="button" class="btn btn-sm ${btnClass}" data-action="${key}" title="${title}">${iconHtml}<span class="dt-btn-label">${label}</span></button>`;
}
